module.exports = __webpack_public_path__ + "static/media/address-card.dfd04d5c.svg";